import { render } from "./SearchResultsAgGrid.vue?vue&type=template&id=8bd7cb7a&scoped=true"
import script from "./SearchResultsAgGrid.vue?vue&type=script&lang=js"
export * from "./SearchResultsAgGrid.vue?vue&type=script&lang=js"

import "./SearchResultsAgGrid.vue?vue&type=style&index=0&id=8bd7cb7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd7cb7a"]])

export default __exports__